// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"0a21141b","453":"e80e51cd","680":"a1261023"}[chunkId] + ".chunk.js";
};